import React from 'react';
import { Button, Tooltip, Tag, Timeline, Icon } from 'antd';

import CustomTable from '../../../components/CustomTable';

export default function ResultList(props) {
    return (
        <CustomTable
            loadingExcel={props.loadingExcel}
            loadingPdf={props.loadingPdf}
            loadingPrint={props.loadingPrint}
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[
                {
                    title: 'Opciones',
                    width: "100px",
                    key: 'options',
                    align: 'center',
                    render: (value, row) => (
                        <div className="custom-options">
                            <Timeline.Item dot={<Icon type="check-circle" style={{ fontSize: '16px' }} />} color="green"></Timeline.Item>

                        </div>
                    )
                },
                {
                    title: 'Configuración',
                    dataIndex: 'configuracion',
                    key: 'configuracion',
                    sorter: true
                },
                {
                    title: 'Módulo',
                    dataIndex: 'modulo',
                    key: 'modulo',
                    sorter: true
                },
                {
                    title: 'Abreviatura',
                    dataIndex: 'abreviatura',
                    key: 'abreviatura',
                    sorter: true
                },
                {
                    title: 'Nombres',
                    dataIndex: 'nombres',
                    key: 'nombres',
                    sorter: true
                },
                {
                    title: 'Apellidos',
                    dataIndex: 'apellidos',
                    key: 'apellidos',
                    sorter: true
                },
                {
                    title: 'Rol',
                    dataIndex: 'nombreRol',
                    key: 'nombreRol',
                    sorter: true
                }

            ]}
        />
    );
}